<div class="g-layout__container">
  <p-confirmDialog></p-confirmDialog>

  <div class="flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <div>
      <h2 class="m-0">{{ 'StrategicKnowledgeLibrary' | navTitle | async }}</h2>
      <div class="text-600 mt-1">{{ 'strategic_knowledge_library_hint' | translate }}</div>
    </div>

    <div class="flex gap-2">
      <button pButton type="button" class="p-button-outlined" (click)="refresh()"
        [label]="'refresh' | translate"></button>
    </div>
  </div>

  @if (canUpload) {
    <div class="card mb-3">
      <div class="grid align-items-end">
        <div class="col-12 md:col-5">
          <label class="block mb-2">{{ 'file_display_name' | translate }}</label>
          <input pInputText type="text" [(ngModel)]="uploadName" class="w-full" />
        </div>

        <div class="col-12 md:col-5">
          <label class="block mb-2">{{ 'select_file' | translate }}</label>
          <input type="file" (change)="onFileSelected($event)" class="w-full" />
        </div>

        <div class="col-12 md:col-2">
          <button pButton type="button" (click)="upload()" [disabled]="!canSubmitUpload"
            [label]="'upload' | translate" class="w-full"></button>
        </div>
      </div>
    </div>
  }

  <p-table [value]="files" [loading]="loading" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50]"
    [showCurrentPageReport]="true" currentPageReportTemplate="{currentPage} / {totalPages}">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 70px">#</th>
        <th>{{ 'file_name' | translate }}</th>
        <th>{{ 'file_type' | translate }}</th>
        <th>{{ 'file_size' | translate }}</th>
        <th>{{ 'upload_date' | translate }}</th>
        <th style="width: 220px">{{ 'actions' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-i="rowIndex">
      <tr>
        <td>{{ i + 1 }}</td>
        <td class="truncate">{{ fileName(row) }}</td>
        <td>{{ row.file_type }}</td>
        <td>{{ formatSize(row.file_size) }}</td>
        <td>{{ row.created_at | date: 'short' }}</td>
        <td>
          <button pButton type="button" class="p-button-sm" (click)="download(row)"
            [label]="'download' | translate"></button>

          @if (canUpload) {
            <button pButton type="button" class="p-button-sm p-button-danger mx-2" (click)="remove(row)"
              [label]="'delete' | translate"></button>
          }
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center py-4 text-600">
          {{ 'no_files' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

